export default __webpack_public_path__ + "images/defaultBanner.144e38d25c99f73057ca28eaf0e9a118.jpg";